const fr = {
  // PROFILE Section
  PROFILE_TITLE: 'Profil',
  PROFILE_TEXT: 'Ingénieur diplômé en 2022, je suis passionné par les technologies web. J\'ai 4 ans d\'expérience à mon actif en start-up et dans un grand groupe, où j\'ai pu progresser et évoluer rapidement. Je recherche actuellement un nouvel emploi en tant que développeur web, gestionnaire de projet.',
  PROFILE_TEXT_2: 'Je suis rigoureux, polyvalent, déterminé et j\'aime relever sans cesse de nouveaux défis. J\'ai une très bonne capacité d\'adaptation et je suis toujours à l\'écoute des personnes qui m\'entourent.',
  PROFILE_TEXT_3: 'J\'ai de l\'expérience dans la gestion de projets, trouvant une réelle satisfaction à travailler sur des initiatives passionnantes et à créer des ponts efficaces entre les exigences métier et les aspects techniques du développement informatique.',

  // FORMATIONS Section
  FORMATION_TITLE: 'Formations',
  FORMATION_OPTIONS_TITLE: 'Formations suivies :',
  FORMATION_PROJECTS_TITLE: 'Projets et associations :',

  // EXPERIENCES Section
  EXPERIENCE_TITLE: 'Expériences professionnelles',
  EXPERIENCE_TECHNOS: 'TECHNOLOGIES UTILISEES',
  EXPERIENCE_MISSIONS: 'MISSIONS PRINCIPALES',

  // SKILLS Section
  SKILL_TITLE: 'Compétences',
  SKILL_ANALYSIS: 'ANALYSE FONCTIONNELLE',

  // LANGUAGES Section
  LANGUAGE_TITLE: 'Langues',
  LANGUAGE_FRENCH: 'Français',
  LANGUAGE_ENGLISH: 'Anglais',
  LANGUAGE_GERMAN: 'Allemand',
  LANGUAGE_TOEIC_TEXT: 'TOEIC : ',
  LANGUAGE_TOEIC_SCORE: '930',

  // USER Section
  USER_FULLNAME: 'Nicolas PIERRE',
  USER_PROFESSION: 'Développeur fullstack',
  USER_ADDRESS: '9 rue d\'Australie, 91300 Massy, France',
  USER_PHONE: '+33 6 51 89 72 48',
  USER_EMAIL: 'npierre9@yahoo.fr',
  USER_BIRTHDATE: 'Date de naissance: 9 Août 1998',
  USER_BIRTHPLACE: 'Lieu de naissance: Massy',
  USER_DRIVING_LICENSE: 'Permis de conduire français',
  USER_BOAT_LICENSE: 'Permis bateau côtier français',

  // INTERESTS section
  INTEREST_TITLE: 'Centres d\'intérêts',
  INTEREST_1: 'Plongée subaquatique',
  INTEREST_1_TEXT: 'Je m\'entraine de manière hebdomadaire en piscine, j\'ai passé mon niveau 2 de plongée et je fais des compétitions de plongée sportive en piscine avec mon club.',
  INTEREST_2: 'Escrime',
  INTEREST_2_TEXT: 'Pratique hebdomadaire de l\'épée en club depuis environ 10 ans, j\'ai gagné quelques médailles en compétitions et je projette d\'en gagner davantage.',
  INTEREST_3: 'Echecs',
  INTEREST_3_TEXT: 'Joueur régulier sur le site Chess.com, niveau intermédiaire ({blitzElo} ELO en blitz, {rapidElo} ELO en rapide), je suis depuis peu inscrit dans un club d\'échecs avec pour ambition de progresser.',
  INTEREST_4: 'Photographie',
  INTEREST_4_TEXT: 'Président du club de photographie et de vidéo de l\'Ecole des Mines lors de l\'année 2019-2020.',
  INTEREST_5: 'Jeux vidéos',
  INTEREST_5_TEXT: 'Fort attachement au monde du jeu vidéo, joueur régulier de jeux compétitifs (Rocket League, Valorant, Counter-Strike), en coopération (Minecraft, Terraria) ou en solo.',

  // EXTERNAL_LINKS Section
  EXTERNAL_LINK_TITLE: 'Réseaux sociaux',
};

export default fr;
